import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from "react";
import MainTemplate from './mainTemplate';
import Home from '../../pages/components/home/home';
import CoursesGrid from '../../pages/components/courses_section/courses_section';
import Course from '../../pages/components/course/course';
import CourseContent from '../../pages/components/course_content/course_content';
import Login from '../../pages/components/login/login';
import ResetPassword from '../../pages/components/login/reset';
import AdminDashboard from '../../pages/components/admin_dashboard/admin_dashboard';
import UserRegister from '../../pages/components/register/register';
import { ProtectedRoute, GuestRoute } from '../../../services/protected';

import Dashboard from '../../pages/components/admin_dashboard/dashboard';

import CategoryList from '../../pages/components/admin_dashboard/category_list';
import CreateCategory from '../../pages/components/admin_dashboard/create_category';
import EditCategory from '../../pages/components/admin_dashboard/edit_category';

import TeacherList from '../../pages/components/admin_dashboard/teacher_list';
import CreateTeacher from '../../pages/components/admin_dashboard/create_teacher';
import EditTeacher from '../../pages/components/admin_dashboard/edit_teacher';

import CourseList from '../../pages/components/admin_dashboard/course_list';
import CreateCourse from '../../pages/components/admin_dashboard/create_course';
import EditCourse from '../../pages/components/admin_dashboard/edit_course';

import ModuleCourseList from '../../pages/components/admin_dashboard/module_course_list';
import ModuleList from '../../pages/components/admin_dashboard/module_by_course';
import CreateModule from '../../pages/components/admin_dashboard/create_module';
import EditModule from '../../pages/components/admin_dashboard/edit_module';

import OrganizationList from '../../pages/components/admin_dashboard/organization_list';
import CreateOrganization from '../../pages/components/admin_dashboard/create_organization';
import EditOrganization from '../../pages/components/admin_dashboard/edit_organization';

import UserList from '../../pages/components/admin_dashboard/user_list';
import CreateUser from '../../pages/components/admin_dashboard/create_user';
import EditUser from '../../pages/components/admin_dashboard/edit_user';

import { ToastContainer } from "react-toastify";
import PageTransition from '../../../services/pageTransition';
import { AnimatePresence } from "framer-motion";
import ScrollToTop from '../../../services/scroll_top';


import CookiePolicy from '../../pages/components/legal/cookie_policy';
import LegalNotes from '../../pages/components/legal/legal_notes';
import PrivacyPolicy from '../../pages/components/legal/privacy_policy';
import Settings from '../../pages/components/admin_dashboard/settings';

import Block from '../../../media/block.png';

import CookieConsent from "react-cookie-consent";

import ConfirmRegistration from '../../pages/components/register/confirm_registration';



function AdminScreenBlocker({ children }) {
  const check = () => window.innerWidth >= 1280;

  const [isAllowed, setIsAllowed] = useState(check());

  useEffect(() => {
    const handleResize = () => setIsAllowed(check());

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isAllowed) return children;

  return (
    <div style={{
      position: "fixed",
      inset: 0,
      background: "white",
      zIndex: 99999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      textAlign: "center"
    }}>
      <img src= {Block} alt="" style={{ width: 128, height: 128}} />
      <h2>Risoluzione non supportata </h2>
      <p>Risoluzione minima: 1280px x 720px</p>
    </div>
  );
}




function AnimatedRoutes() {
  const location = useLocation(); 
  

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* Layout globale */}
        <Route path="/" element={<MainTemplate />}>
          {/* Pagine pubbliche */}
          <Route path="/course/:slug" element={<PageTransition><Course /></PageTransition>} />
          <Route index element={<PageTransition><Home /></PageTransition>} />
          <Route path="/courses" element={<PageTransition><CoursesGrid /></PageTransition>} />
          <Route path="/cookie-policy" element={<PageTransition><CookiePolicy /></PageTransition>} />
          <Route path="/informativa-privacy" element={<PageTransition><PrivacyPolicy /></PageTransition>} />
          <Route path="/note-legali" element={<PageTransition><LegalNotes /></PageTransition>} />
          <Route path="/login" element={<GuestRoute><PageTransition><Login /></PageTransition></GuestRoute>} />
          <Route path="/reset-password/:uid/:token" element={<GuestRoute><PageTransition><ResetPassword /></PageTransition></GuestRoute>}/>
          <Route path="/confirm-registration/:token" element={<GuestRoute><PageTransition><ConfirmRegistration /></PageTransition></GuestRoute>}/>
          <Route path="/create-account" element={<GuestRoute><PageTransition><UserRegister /></PageTransition></GuestRoute>} />
        </Route>
        <Route
            path="/course-content/:slug"
            element={
              <ProtectedRoute>
                <CourseContent />
              </ProtectedRoute>
            }
          />
        {/* Admin dashboard */}
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminScreenBlocker>
                  <AdminDashboard />
                </AdminScreenBlocker>
              </ProtectedRoute>
            }
          >
            {/* Dashboard riepilogo */}
            <Route path="" element={<Dashboard />} />
            

            {/* Categorie */}
            <Route path="categorie" element={<CategoryList />} />
            <Route path="categorie/crea" element={<CreateCategory />} />
            <Route path="categorie/modifica/:slug" element={<EditCategory />} />

            {/* Insegnanti */}
            <Route path="insegnanti" element={<TeacherList />} />
            <Route path="insegnanti/crea" element={<CreateTeacher />} />
            <Route path="insegnanti/modifica/:slug" element={<EditTeacher />} />

            {/* Corsi */}
            <Route path="corsi" element={<CourseList />} />
            <Route path="corsi/crea" element={<CreateCourse />} />
            <Route path="corsi/modifica/:slug" element={<EditCourse />} />

            {/* Moduli */}
            <Route path="moduli/crea/:slug" element={<CreateModule />} />
            <Route path="moduli/modifica/:slug" element={<EditModule />} />
            <Route path="moduli/gestisci/:slug" element={<ModuleList />} />

            {/* Enti */}
            <Route path="enti" element={<OrganizationList />} />
            <Route path="enti/crea" element={<CreateOrganization />} />
            <Route path="enti/modifica/:slug" element={<EditOrganization />} />

            {/* Utenti */}
            <Route path="utenti" element={<UserList />} />
            <Route path="utenti/crea" element={<CreateUser />} />
            <Route path="utenti/modifica/:slug" element={<EditUser />} />

            {/* Impostazioni */}
             <Route path="impostazioni" element={<Settings />} />
          </Route>
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={6000} />
      <ScrollToTop />
      <AnimatedRoutes />
      <CookieConsent
        location="bottom"
        buttonText="Accetta"
        declineButtonText="Rifiuta"
        enableDeclineButton
        cookieName="cookie_consent"
        expires={365}
        buttonClasses="btn-accept"
        declineButtonClasses="btn-reject"
      >
        Questo sito utilizza cookie per migliorare l'esperienza di navigazione.
      </CookieConsent>
    </BrowserRouter>
  );
}

export default App;
